import '../../scss/live.scss';

const $ = require('jquery');

import {initFilters} from "../collection/filters";

$(document).ready(function () {
    initFilters();
    console.log('Page ready');
});
